import React, { useState, useEffect } from "react";
import { Upload, Button, message, Card, Spin, Input } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import CustomTable from "../Reports/customTable";
import { getSeqFiles, uploadSeqFile } from "../../core/api/database";
import { getCurrentUser } from "../../core/api/settings";
import { getProfileTest } from "../../core/api/auth";
import { useSelector } from "react-redux";

const MailFilesTab = () => {
  const profile = useSelector((state) => state.profile);
  console.log("Profile in MailFilesTab component:",profile);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");


  useEffect(() => {
    fetchFileData();
  }, []);

   useEffect(() => {
    const fetchPermissions = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      if (token) {
        try {
          sessionStorage.setItem("page_permissions", JSON.stringify(profile?.page_permissions));
          sessionStorage.setItem("page_authorization", JSON.stringify(profile?.page_authorization));
          sessionStorage.setItem("user_role", profile?.role);
          // Set other session keys as needed
        } catch (e) {
          console.error("Failed to fetch permissions", e);
        }
      }
    };
    fetchPermissions();
    }, [profile]);

  const fetchFileData = async () => {
    setLoading(true);
    try {
      const response = await getSeqFiles();
      setFileData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching file data:", error);
      message.error("Failed to fetch file data");
      setLoading(false);
    }
  };

  const handleUpload = async () => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("files[]", file);
    });
    
    // Add comment to form data
    formData.append("comment", comment);

    setUploading(true);

    try {
      await uploadSeqFile(formData);
      setFileList([]);
      setComment(""); // Reset comment after successful upload
      message.success("File uploaded successfully");
      fetchFileData(); // Refresh the file list
    } catch (error) {
      console.error("Error uploading file:", error);
      message.error("File upload failed");
    } finally {
      setUploading(false);
    }
  };

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      // Check if file is a .seq file
      if (!file.name.endsWith('.seq') && !file.name.endsWith('.cln.seq')) {
        message.error(`${file.name} is not a .seq file`);
        return Upload.LIST_IGNORE;
      }
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const columns = [
    { header: "File Code", accessor: "file_code" },
    { header: "File Name", accessor: "file_name" },
    { header: "Records Count", accessor: "records_count" },
    { header: "Upload Date", accessor: "upload_date" },
    { header: "Comment", accessor: "comment" },
  ];

  const pageAuthorizations = sessionStorage.getItem("page_authorization") || "";
  const userRole = sessionStorage.getItem("user_role");

  
  const canAddMail =  userRole === "super_admin" ||  pageAuthorizations.includes("/mail-files_create*");
  const canEditMail =  userRole === "super_admin" || pageAuthorizations.includes("/mail-files_edit*");
  const canDeleteMail =  userRole === "super_admin" || pageAuthorizations.includes("/mail-files_delete*");
  const canDownloadMail =  userRole === "super_admin"|| pageAuthorizations.includes("/mail-files_download*");


    // Permission check
    
  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-4">Mail Files Upload</h4>
        <div className="row">
          <div className="col-md-6">
            <Card title="Upload .seq Files" className="mb-4">
              <Upload {...props} multiple>
                <Button icon={<UploadOutlined />}>Select Files</Button>
              </Upload>
              <div style={{ marginTop: 16, marginBottom: 16 }}>
                <Input.TextArea
                  placeholder="Add a comment about these files (optional)"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  rows={3}
                />
              </div>
              <Button
                type="primary"
                onClick={handleUpload}
                disabled={fileList.length === 0}
                loading={uploading}
                style={{ marginTop: 16 }}
              >
                {uploading ? "Uploading" : "Start Upload"}
              </Button>
            </Card>
          </div>
        </div>

        <h4 className="mb-4">Uploaded Files</h4>
        {loading ? (
          <div className="text-center">
            <Spin size="large" />
          </div>
        ) : (
          <CustomTable
            columns={columns}
            data={fileData}
            loading={loading}
            storageKey="mail_files_table"
          />
        )}
      </div>
    </div>
  );
};

export default MailFilesTab;
